"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToggleSubscription;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _checkbox = _interopRequireDefault(require("@ux/checkbox"));
var _traffic = require("@site/pattern-library-utils/traffic");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const ToggleSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ToggleSection",
  class: "pl-tqli9u1"
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-c1v9sow3"
});

/**
 * ToggleSubscription Component.
 *
 * @param {Object} props React props
 * @param {string} props.displayName Display name
 * @param {string} props.displayDescription Display description
 * @param {boolean} props.checked Checked state
 * @param {Function} props.onToggle Toggle function
 * @returns {React.ReactElement} ToggleSection Component
 * @public
 */
function ToggleSubscription({
  displayName,
  displayDescription,
  checked,
  onToggle
}) {
  const handleChange = () => {
    onToggle();
    (0, _traffic.logEvent)({
      eid: `gce.sales.subscription/unsubscribe.lists.list-item-${displayName}.checkbox`,
      type: 'click'
    });
  };
  return /*#__PURE__*/_react.default.createElement(ToggleSection, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    id: "subscription-checkbox",
    name: "subscription-toggle",
    checked: checked,
    onChange: handleChange,
    "aria-label": `${displayName} toggle`,
    "data-eid": `gce.sales.subscription/unsubscribe.lists.list-item-${displayName}.checkbox`
  })), /*#__PURE__*/_react.default.createElement(Content, null, displayName && /*#__PURE__*/_react.default.createElement(_text.default.h6, {
    as: "title",
    className: "display-name",
    size: 1,
    text: displayName
  }), displayDescription && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: displayDescription
  })));
}
ToggleSubscription.propTypes = {
  displayName: _propTypes.default.string.isRequired,
  displayDescription: _propTypes.default.string,
  checked: _propTypes.default.bool.isRequired,
  onToggle: _propTypes.default.func.isRequired
};